<button
  class="cx-hamburger"
  type="button"
  (click)="toggle()"
  [class.is-active]="isExpanded | async"
  [attr.aria-expanded]="isExpanded | async"
  [attr.aria-label]="'common.menu' | cxTranslate"
  aria-controls="cx-header"
>
  <span class="hamburger-box">
    <span class="hamburger-inner"></span>
  </span>
</button>
